// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.job-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.job-card-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.job-card-body {
  padding: 1rem 1.2rem;
}

.job-card-badges {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.badge {
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-online {
  background: #dbeafe;
  color: #1d4ed8;
}

.badge-irl {
  background: #dcfce7;
  color: #15803d;
}

.badge-category {
  background: #f3f4f6;
  color: #374151;
}

.job-card-title {
  margin: 0 0 0.4rem;
  font-size: 1.1rem;
  color: #111827;
}

.job-card-desc {
  color: #6b7280;
  font-size: 0.9rem;
  line-height: 1.4;
  margin: 0 0 0.5rem;
}

.job-card-location {
  color: #9ca3af;
  font-size: 0.85rem;
  margin: 0 0 0.5rem;
}

.job-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.8rem;
  padding-top: 0.8rem;
  border-top: 1px solid #f3f4f6;
}

.job-card-price {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2563eb;
}

.accept-btn {
  background: #2563eb;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
}

.accept-btn:hover {
  background: #1e40af;
}
`, "",{"version":3,"sources":["webpack://./src/JobCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".job-card {\n  background: white;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.job-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.job-card-image {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n}\n\n.job-card-body {\n  padding: 1rem 1.2rem;\n}\n\n.job-card-badges {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.badge {\n  padding: 0.2rem 0.6rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.badge-online {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.badge-irl {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.badge-category {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.job-card-title {\n  margin: 0 0 0.4rem;\n  font-size: 1.1rem;\n  color: #111827;\n}\n\n.job-card-desc {\n  color: #6b7280;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  margin: 0 0 0.5rem;\n}\n\n.job-card-location {\n  color: #9ca3af;\n  font-size: 0.85rem;\n  margin: 0 0 0.5rem;\n}\n\n.job-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.8rem;\n  padding-top: 0.8rem;\n  border-top: 1px solid #f3f4f6;\n}\n\n.job-card-price {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #2563eb;\n}\n\n.accept-btn {\n  background: #2563eb;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.accept-btn:hover {\n  background: #1e40af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
